angular.module('env.data.repos',
    [
        'env.data.repos.addresses',
        'env.data.repos.categoryTypes',
        'env.data.repos.categories',
        'env.data.repos.centres',
        'env.data.repos.customers',
        'env.data.repos.documents',
        'env.data.repos.groups',
        'env.data.repos.localization',
        'env.data.repos.operations',
        'env.data.repos.orderItems',
        'env.data.repos.orders',
        'env.data.repos.users',
        'env.data.repos.workflow'
    ]
);